<template>
    <v-dialog v-model="dialog" @keydown.esc="closeModal()" persistent max-width="600px">
        <template v-slot:activator="{ on }"> 
            <v-btn  outlined color="#FFFFFF" class="ml-3" x-large dark v-on="on">
                Deixe uma Mensagem para os Papais
            </v-btn> 
        </template>
            <v-card>
                <v-card-text>
                    <v-row dense align="center" align-content="center" justify="center">
                        <v-col order="1" cols="12">
                            <span class="title"> Dados da Mensagem</span>
                            <v-text-field v-model="nome" :rules="[rules.maxlength(200), rules.required]" label="Deixe o seu nome"></v-text-field>
                            <v-textarea v-model="mensagem" :rules="[rules.maxlength(200), rules.required]" auto-grow counter="200" label="Digite a mensagem"></v-textarea>
                        </v-col>                              
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>            
                    <v-btn color="blue darken-1" text @click="saveMessage">Enviar</v-btn>
                </v-card-actions>                 
            </v-card>
    </v-dialog>
</template>
<script>
import {db} from '@/main.js'

export default {
    props: ['revelacaoId', 'url'],
    data: () => ({
        rules: {
            required: value => !!value || 'Campo Obrigatório.', 
            minlength: len => v => (v || '').length >= len || `Número de Caractéres Inválido. Mínimo: ${len}`,
            maxlength: len => v => (v || '').length < len || `Número de Caractéres Inválido. Máximo: ${len}`,
        },
        mensagem: '',
        nome: '',
        dialog: false,
        mensagens: [],
    }),
    created(){
        this.end = this.endereco
        this.listaPresentes = this.presentes
    },
    methods:{
        async loadMessages(){
            await db.collection('revelacoes').where('URL','==',this.url).get()
            .then((seg) => {    
                this.mensagens = seg.docs.map(doc => {let a = doc.data(); a.id = doc.id; return a}); 
                this.mensagens = this.mensagens[0].mensagens || []
            }).catch(function (error) {
                console.error("Error get Votos: ", error);
            }); 
        },        
        async saveMessage(){
            await this.loadMessages()
            let msg = {
                'nome': this.nome,
                'mensagem': this.mensagem
            }
            this.mensagens.push(msg)
            let listaMensagem = {
                "mensagens": this.mensagens
            }
            // console.log("Salvando",this.mensagens)
            db.collection('revelacoes').doc(this.revelacaoId).update(listaMensagem).then(async() => {
                this.loading = false
                this.nome = ''
                this.mensagem = ''
                this.$emit("loadMessage")                
            }).catch(function (error) {
                console.error('Error to Save Information - storePage : ' + error)
            })               
          this.dialog = false
        },      
    },     
}
</script>